import type { RegisterImplementationProps } from 'constants/types';
import MultiSignInBase, { type MultiSignInStep } from '../MultiSignInBase';
import { getProviderFormLabel } from '../utils';
import Welcome from './MultiSignIn/Welcome';
import Webservice from './MultiSignIn/Webservice';
import CreateSecurityProfile from './MultiSignIn/CreateSecurityProfile';
import Credentials from './MultiSignIn/Credentials';

const SignInUKGReadyApiMultiStep = ({
  client,
  isLoading,
  onSubmit,
  provider,
  instructionsLink,
  instructionsInnerHtmlToScroll,
  instructionsInnerHtmlToScrollStep2,
  instructionsInnerHtmlToScrollStep3,
}: RegisterImplementationProps) => {
  const steps: MultiSignInStep[] = [
    {
      id: 'welcome',
      title: `Let's create your connection`,
      fieldNames: [],
      welcomePage: true,
      spacing: 'md',
    },
    {
      id: 'webservice',
      title: 'Retrieve the Web Service URL and Company Short Name',
      fieldNames: ['fullDomain', 'clientCode'],
      spacing: 'sm',
    },
    {
      id: 'createSecurityProfile',
      title: 'Create a Security Profile',
      fieldNames: ['securityProfileConfirmed'],
      spacing: 'sm',
    },
    {
      id: 'credentials',
      title: 'Create a Service Account',
      fieldNames: ['username', 'password', 'apiToken'],
      spacing: 'sm',
    },
  ];

  return (
    <MultiSignInBase
      formLabel={getProviderFormLabel(provider)}
      steps={steps}
      onSubmit={onSubmit}
      isLoading={isLoading}
      render={(fields, currentStep) => {
        // Step 0: Welcome page
        if (currentStep === 0) {
          return <Welcome client={client} provider={provider} />;
        }

        // Step 1: Webservice
        if (currentStep === 1) {
          return (
            <Webservice
              instructionsLink={instructionsLink}
              instructionsInnerHtmlToScroll={instructionsInnerHtmlToScroll}
              clientCode={fields.clientCode}
              fullDomain={fields.fullDomain}
            />
          );
        }

        // Step 2: Create Security Profile
        if (currentStep === 2) {
          return (
            <CreateSecurityProfile
              securityProfileConfirmed={fields.securityProfileConfirmed}
              instructionsLink={instructionsLink}
              instructionsInnerHtmlToScroll={instructionsInnerHtmlToScrollStep2}
            />
          );
        }

        // Step 3: Credentials
        if (currentStep === 3) {
          return (
            <Credentials
              username={fields.username}
              password={fields.password}
              apiToken={fields.apiToken}
              instructionsLink={instructionsLink}
              instructionsInnerHtmlToScroll={instructionsInnerHtmlToScrollStep3}
            />
          );
        }

        return null;
      }}
    />
  );
};

export default SignInUKGReadyApiMultiStep;
